module.exports = __webpack_public_path__ + "img/zz-row-two.0c3eecd2.svg";